import styled from 'styled-components';

export const StyledWriteUpContainer = styled.div`
  width: 100%;
`;

export const StyledWriteUpCommunityContainer = styled.div`
  width: 100%;
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;
